import {
  Card, CardBody, CardHeader, Heading, Skeleton,
} from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { CompanyUpdateForm } from "components/Forms/Admin/Company";
import { companyKeys, useAdminCompanyQuery } from "features/Company/hooks";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import { Company } from "models/company";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router";

export default function CompanyPage() {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const { setPageTitle } = useNavbar();
  const { data: company, isLoading } = useAdminCompanyQuery(id || "");
  const onSuccess = useCallback(
    (res: Company) => {
      queryClient.invalidateQueries({ queryKey: companyKeys.admin() });
      queryClient.invalidateQueries({ queryKey: companyKeys.adminDetail(res.id) });
    },
    [queryClient],
  );

  useEffect(() => {
    setPageTitle("Company Details");
  }, [setPageTitle]);

  return (
    <AppPage>
      <Card>
        <CardHeader>
          <Heading size="xs" textTransform="capitalize">
            Company Details
          </Heading>
        </CardHeader>
        <CardBody>
          <Skeleton isLoaded={!isLoading} height="100%">
            {company && <CompanyUpdateForm company={company} onSuccess={onSuccess} />}
          </Skeleton>
        </CardBody>
      </Card>
    </AppPage>
  );
}
